import { render } from "./MessageSection.vue?vue&type=template&id=01ef95f8"
import script from "./MessageSection.vue?vue&type=script&lang=js"
export * from "./MessageSection.vue?vue&type=script&lang=js"

import "./MessageSection.vue?vue&type=style&index=0&id=01ef95f8&lang=scss"

import exportComponent from "E:\\projects\\EUP_BITBUCKET\\edriver_chat\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__